import * as React from 'react';
import { useSelector } from 'react-redux';
import { OfferCard } from './OfferCard';
import { PromoModal } from './PromoModal';
import { selectPromoOffer } from '../../selectors/promoOffersSelection/promoOffersSelector';
import { IApplicationState } from '../../types/redux';
import { PromoOfferCardContext } from '../../utils/promoOfferCardContext';
import { trackBlockClick } from '../PromoOffersSelection/tracking';

interface IPromoOfferCardContainerProps {
  cardId: number;
}

export const PromoOfferCardContainer = ({ cardId }: IPromoOfferCardContainerProps) => {
  const promoOffer = useSelector((state: IApplicationState) => selectPromoOffer(state, cardId));

  const [opened, setOpened] = React.useState(false);

  const onPromoModalOpen = React.useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();

      if (promoOffer) {
        trackBlockClick({ offersIds: [promoOffer.offerId], clickType: 'to_promo' });
        setOpened(true);
      }
    },
    [promoOffer],
  );

  const onPromoModalClose = React.useCallback(() => {
    setOpened(false);
  }, []);

  if (!promoOffer) {
    return null;
  }

  return (
    <PromoOfferCardContext.Provider value={promoOffer}>
      <OfferCard onPromoModalOpen={onPromoModalOpen} />
      {opened && <PromoModal onPromoModalClose={onPromoModalClose} />}
    </PromoOfferCardContext.Provider>
  );
};
